/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BatchSmsJobDto } from '../model/batchSmsJobDto';
import { SmtpSettings } from '../model/smtpSettings';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmtpSettingsService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smtpSettingsAddSmtpSettings(model: SmtpSettings, observe?: 'body', reportProgress?: boolean): Observable<SmtpSettings>;
    public smtpSettingsAddSmtpSettings(model: SmtpSettings, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmtpSettings>>;
    public smtpSettingsAddSmtpSettings(model: SmtpSettings, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmtpSettings>>;
    public smtpSettingsAddSmtpSettings(model: SmtpSettings, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smtpSettingsAddSmtpSettings.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SmtpSettings>(`${this.basePath}/api/SmtpSettings/AddSmtpSettings`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smtpSettingsDelete(model: SmtpSettings, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smtpSettingsDelete(model: SmtpSettings, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smtpSettingsDelete(model: SmtpSettings, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smtpSettingsDelete(model: SmtpSettings, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smtpSettingsDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/SmtpSettings/Delete`,
            model,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param stringidfiedId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smtpSettingsGetById(stringidfiedId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmtpSettings>;
    public smtpSettingsGetById(stringidfiedId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmtpSettings>>;
    public smtpSettingsGetById(stringidfiedId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmtpSettings>>;
    public smtpSettingsGetById(stringidfiedId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (stringidfiedId !== undefined && stringidfiedId !== null) {
            queryParameters = queryParameters.set('stringidfiedId', <any>stringidfiedId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmtpSettings>(`${this.basePath}/api/SmtpSettings/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smtpUsername 
     * @param smtpPassword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smtpSettingsGetDefaultSettings(smtpUsername?: string, smtpPassword?: string, observe?: 'body', reportProgress?: boolean): Observable<BatchSmsJobDto>;
    public smtpSettingsGetDefaultSettings(smtpUsername?: string, smtpPassword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchSmsJobDto>>;
    public smtpSettingsGetDefaultSettings(smtpUsername?: string, smtpPassword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchSmsJobDto>>;
    public smtpSettingsGetDefaultSettings(smtpUsername?: string, smtpPassword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (smtpUsername !== undefined && smtpUsername !== null) {
            queryParameters = queryParameters.set('smtpUsername', <any>smtpUsername);
        }
        if (smtpPassword !== undefined && smtpPassword !== null) {
            queryParameters = queryParameters.set('smtpPassword', <any>smtpPassword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BatchSmsJobDto>(`${this.basePath}/api/SmtpSettings/GetDefaultSettings`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smtpSettingsUpdate(model: SmtpSettings, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smtpSettingsUpdate(model: SmtpSettings, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smtpSettingsUpdate(model: SmtpSettings, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smtpSettingsUpdate(model: SmtpSettings, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smtpSettingsUpdate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/SmtpSettings/Update`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
